import { render, staticRenderFns } from "./ReminderSuccess.vue?vue&type=template&id=b770b846&scoped=true&"
import script from "./ReminderSuccess.vue?vue&type=script&lang=js&"
export * from "./ReminderSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ReminderSuccess.vue?vue&type=style&index=0&id=b770b846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b770b846",
  null
  
)

export default component.exports